import { render, staticRenderFns } from "./geopoint.vue?vue&type=template&id=2d85d0ee&scoped=true"
import script from "./geopoint.vue?vue&type=script&lang=js"
export * from "./geopoint.vue?vue&type=script&lang=js"
import style0 from "./geopoint.vue?vue&type=style&index=0&id=2d85d0ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d85d0ee",
  null
  
)

export default component.exports